import { render, staticRenderFns } from "./ClosePermanent.vue?vue&type=template&id=ed6cc6d0&lang=pug"
import script from "./ClosePermanent.vue?vue&type=script&lang=js"
export * from "./ClosePermanent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports